import {
  ChangeDetectionStrategy,
  Component,
  Directive,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { kebabCase } from 'lodash';
import { IRouter } from '../../interfaces/router.interface';
import { IIcon } from '../icon/icon.interface';
import { GlobalHeaderThemesEnum } from './global-header-themes.enum';

@Directive({
  selector: 'center-slot, right-slot',
})
export class GlobalHeaderComponentTagsDirective {}

export const GlobalHeaderComponentDirectives = [
  GlobalHeaderComponentTagsDirective,
];

@Component({
  selector: 'app-global-header',
  templateUrl: 'global-header.component.html',
  styleUrls: ['global-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GlobalHeaderComponent implements OnInit {
  @Input() theme: GlobalHeaderThemesEnum = GlobalHeaderThemesEnum.simple;
  @Input() goBackRoute: IRouter | string;
  @Input() header: string;
  @Input() headerIcon: IIcon;
  @Input() disableGlobalBanner: boolean;

  @Output() onClickHeaderIcon: EventEmitter<void> = new EventEmitter<void>();

  headerTheme: string;

  ngOnInit() {
    this.headerTheme = kebabCase(this.theme);
  }
}
